export enum TranslationLanguages {
  en = "en",
  ua = "ua",
  de = "de",
  es = "es"
}

export interface Translation {
  en: string;
  ua: string;
  de: string;
  es: string;
}

export interface FAQ {
  question: Translation;
  answer: Translation;
  cities: string[];
  _id: string;
}

export type NewFAQ = Omit<FAQ, '_id'>;
